"use strict";

var dgv = dgv || {};


dgv.mobileMenu = dgv.mobileMenu || function () {

    function init(){
        var target = document.querySelectorAll('.site-header__menu .menu-item');


        for (let i = 0; i < target.length; i++){
            target[i].addEventListener('click', function () {
                this.classList.toggle('show-sub-menu');
            });
        }
        // target.forEach(function() {
        //     this.addEventListener('click', function () {
        //         console.log('asdf')
        //         this.classList.toggle('show-sub-menu');
        //     });
        // });

    }


    return {
        init: init,
    };



}();
